import request from '../utils/request'
const serviceName = 'admOrg'

export function getAdmOrgTree(data) {
  return request({
    url:`/${serviceName}/getAdmOrgTree`,
    method:'post',
    data
  })
}

export function getAdmOrgTreeChecked(data) {
  return request({
    url:`/${serviceName}/getAdmOrgTree`+data,
    method:'get',
  })
}


export function getAdmOrgList(data) {
  return request({
    url:`/${serviceName}/getAdmOrgList`,
    method:'post',
    data
  })
}

export function addOrUpdateAdmOrg(newFormFlag, data,params) {
  var url
  if (newFormFlag) {
    url = 'addAdmOrg'
  } else {
    url = 'updateAdmOrg'
  }
  return request({
    url:`/${serviceName}/${url}`,
    method:'post',
    data,
    params: params
  })
}

export function deleteAdmOrg(data) {
  return request({
    url:`/${serviceName}/deleteAdmOrg`,
    method:'post',
    data
  })
}

export function setAdmin(data) {
  return request({
    url:`/${serviceName}/setAdmin`,
    method:'post',
    data
  })
}

export function getAdmOrgAndUserTree(data) {
  return request({
    url:`/${serviceName}/getAdmOrgAndUserTree`,
    method:'post',
    data
  })
}



// WEBPACK FOOTER //
// ./src/api/admOrg.js